import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AvatarWithName from 'reusable/mui/avatar-with-name/AvatarWithName'
import { themeConfig } from '@gap/shared/theme'

const maxVisibleAvatars = 3

interface AdvisorAccessAvatarsProps {
   users: { id: string, name: string, email: string }[]
}

export default observer(function AdvisorAccessAvatars({ users }: AdvisorAccessAvatarsProps) {
   if (users.length === 0) return null

   const visibleUsers = users.slice(0, maxVisibleAvatars)
   const overflowCount = users.length - maxVisibleAvatars

   return <Box sx={{ display: 'flex', alignItems: 'center', '& > *:not(:first-of-type)': { ml: -1 } }}>
      {visibleUsers.map(user => <AvatarWithName key={user.id} name={user.name} small />)}
      {overflowCount > 0 && <Typography variant="caption" sx={{ ml: 0.5, fontWeight: 600, color: themeConfig.primary[500] }}>
         +{overflowCount}
      </Typography>}
   </Box>
})
